import { createFileRoute } from '@tanstack/react-router';
import DocsGroupLayout from '@/components/Docs/DocsGroupLayout';

export const Route = createFileRoute('/docs')({
  component: DocsLayout,
});

function DocsLayout() {
  return <DocsGroupLayout group="documentation" />;
}
